module.exports = __webpack_public_path__ + "img/SKMJ_ladder4.2a1cc45b.png";